import React from "react";

const steps = [
  {
    step: "STEP 01",
    title: "Create Your Profile",
    desc: "Share your journey and preferences",
  },
  {
    step: "STEP 02",
    title: "Find your community",
    desc: "Connect with families who understand",
  },
  {
    step: "STEP 03",
    title: "Access Resources",
    desc: "Discover verified support and guidance",
  },
  {
    step: "STEP 04",
    title: "Build Connections",
    desc: "Join local events and grow together",
  },
];

/**
 * How It Works — Stitch our-app.html §4
 */
const Howitworks = () => {
  return (
    <section
      className="py-16 sm:py-20 md:py-24 relative text-left"
      style={{ backgroundColor: "var(--color-surface-light)" }}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
        <div className="flex flex-col items-start mb-10 sm:mb-16">
          <span className="inline-block px-3.5 py-1 rounded-full bg-cloud-mist text-spectrum-blue text-xs font-headline font-bold tracking-wider mb-4">
            SIMPLE STEPS
          </span>
          <h2 className="font-headline text-2xl sm:text-3xl lg:text-4xl text-ink tracking-tight">
            <span className="font-light">How It </span>
            <span className="font-extrabold text-spectrum-blue">Works</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {steps.map((item) => (
            <article
              key={item.step}
              className="bg-surface-white p-5 sm:p-6 rounded-brand border border-cloud-mist shadow-brand-sm flex flex-col text-left h-full"
            >
              <div className="flex justify-between items-center mb-5 sm:mb-6">
                <span
                  className="px-3 py-1 rounded-full text-spectrum-blue text-xs font-headline font-extrabold"
                  style={{
                    backgroundColor:
                      "color-mix(in srgb, var(--color-spectrum-blue) 10%, var(--color-white))",
                  }}
                >
                  {item.step}
                </span>
              </div>
              <h3 className="font-headline font-bold text-base sm:text-lg text-spectrum-blue mb-2">
                {item.title}
              </h3>
              <p className="font-body text-sm text-muted mt-auto">
                {item.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Howitworks;
